import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CreditMultiStepLoadPollingRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CreditMultiStepLoadPollingResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const creditMultiStepPoll = (request: CreditMultiStepLoadPollingRequest, options?: CashRequestOptions) =>
  post<CreditMultiStepLoadPollingRequest, CreditMultiStepLoadPollingResponse>(
    '/2.0/cash/credit-multi-step-poll',
    request,
    { ...options, rejectOnError: true }
  )
